/* open-inbox-chat.js */
(function () {
  'use strict';

  function getHost() {
    return (
      document.querySelector('inbox-online-store-chat') ||
      document.querySelector('#shopify-chat inbox-online-store-chat')
    );
  }

  function getToggleButton(host) {
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('[data-spec="toggle-button"]');
  }

  function setChatHash() {
    const base = location.pathname + location.search;
    if (location.hash !== '#chat') history.replaceState(null, '', base + '#chat');
  }

  function clearChatHash() {
    const base = location.pathname + location.search;
    if (location.hash === '#chat') history.replaceState(null, '', base);
  }

  function openShopifyInbox() {
    const host = getHost();
    if (!host) return;

    // Preferred: set attribute Shopify Inbox listens for
    host.setAttribute('is-open', 'true');

    // Fallback: click the internal toggle if present and closed
    try {
      const btn = getToggleButton(host);
      if (btn && btn.getAttribute('aria-expanded') === 'false') btn.click();
    } catch (_) {
      /* ignore */
    }
  }

  function closeShopifyInbox() {
    const host = getHost();
    if (!host) return;

    host.setAttribute('is-open', 'false');

    try {
      const btn = getToggleButton(host);
      if (btn && btn.getAttribute('aria-expanded') === 'true') btn.click();
    } catch (_) {
      /* ignore */
    }
  }

  // Delegate link clicks:
  document.addEventListener('click', function (e) {
    // Rich text links often can only be set to "#chat" (or a full URL ending with "#chat")
    const openHash = e.target.closest('a[href="#chat"], a[href$="#chat"]');
    if (openHash) {
      e.preventDefault();
      openShopifyInbox();
      setChatHash();
      return;
    }

    const open = e.target.closest('a[data-open-chat]');
    if (open) {
      e.preventDefault();
      openShopifyInbox();
      return;
    }

    const close = e.target.closest('a[data-close-chat]');
    if (close) {
      e.preventDefault();
      closeShopifyInbox();
      clearChatHash();
    }
  });

  function bindChatBubbleHashSync() {
    const host = getHost();
    if (!host) return false;

    let btn = null;
    try {
      btn = getToggleButton(host);
    } catch (_) {
      btn = null;
    }

    if (!btn || btn.__hashSyncBound) return !!btn;

    btn.__hashSyncBound = true;

    btn.addEventListener(
      'click',
      function () {
        // Let Shopify update aria-expanded first
        setTimeout(function () {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          if (expanded) setChatHash();
          else clearChatHash();
        }, 0);
      },
      true
    );

    return true;
  }

  // Run now, and also when the widget loads later
  if (!bindChatBubbleHashSync()) {
    const mo = new MutationObserver(function () {
      if (bindChatBubbleHashSync()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function openFromHashIfNeeded() {
    if (location.hash === '#chat') openShopifyInbox();
  }

  // Deep link support on page load and hash changes
  openFromHashIfNeeded();
  window.addEventListener('hashchange', openFromHashIfNeeded);

  // Optional: expose helpers
  window.openShopifyInbox = openShopifyInbox;
  window.closeShopifyInbox = closeShopifyInbox;
})();
